import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "plugin-management"
    }}>{`Plugin management`}</h1>
    <p>{`The UXP Developer Tool allows you to create plugins from templates and add existing ones to your developer workspace.`}</p>
    <p>{`You can add as many plugins as you want in the UXP Developer Tool. You can either create the plugin folder structure and files from scratch and click the `}<inlineCode parentName="p">{`Add Plugin`}</inlineCode>{` button in the Tool, or you can click the `}<inlineCode parentName="p">{`Create Plugin`}</inlineCode>{` button to have it created for you, wizard-style. `}</p>
    <h2 {...{
      "id": "creating-a-new-plugin"
    }}>{`Creating a new plugin`}</h2>
    <p>{`As demonstrated while writing your first plugin, "Create Plugin" lets you select a template and create a new plugin instantly. Just fill out the name and select a template. It's that simple!`}</p>
    <h2 {...{
      "id": "adding-an-existing-plugin"
    }}>{`Adding an existing plugin`}</h2>
    <p>{`You're not limited to creating new plugins from the Developer Tool – you can add plugins that you've already started as well.`}</p>
    <ul>
      <li parentName="ul">{`Click `}<strong parentName="li">{`Add Plugin`}</strong></li>
      <li parentName="ul">{`A file picker will appear. This picker expects you to pick the `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{` in your plugin folder.`}</li>
      <li parentName="ul">{`Once you close the picker, the plugin will be added to your workspace.`}</li>
    </ul>
    <h2 {...{
      "id": "removing-a-plugin"
    }}>{`Removing a plugin`}</h2>
    <p>{`If you're building a lot of plugins, you may find that the workspace may be getting cluttered. You can remove a plugin from the workspace by checking the plugin's associated checkbox and clicking `}<strong parentName="p">{`Remove Selected`}</strong>{` (in the upper-right corner). `}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Removing a plugin from the Developer Tool's workspace does `}<strong parentName="p">{`not`}</strong>{` remove the plugin from your storage. You can always add the plugin back later.`}</p>
    <p>{`Once you have at least one plugin added to your workspace, let's look at the actions you can perform on them in the `}<a parentName="p" {...{
        "href": "./plugin-workflows"
      }}>{`next section`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      